import { AxiosService, isRequestCanceled } from './axios.service'
import fileSaver from '../helpers/download.helper'

const baseURL = 'muvicard'

/**
 * Defines the API methods for an user ticket
 */
export class MuvicardService {
	/**
	 * Get personal data
	 * @return {Promise<any[]>}
	 */
	static getPersonaldata() {
		return AxiosService.get(`${baseURL}/buscar-dados-para-proposta`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Update muvicard personal data
	 * @return {Promise<any[]>}
	 */
	static sendPersonalData(dados) {
		return AxiosService.post(`${baseURL}/atualizar-dados-pessoais`, dados)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Proposal Request
	 * @return {Promise<any[]>}
	 */
	static proposalRequest() {
		return AxiosService.post(`${baseURL}/solicitar-proposta`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Update muvicard status step
	 * @return {Promise<any[]>}
	 */

	static proposalStepRegister(step, status) {
		var params = {
			step,
			status,
		}
		return AxiosService.post(`${baseURL}/registrar-passo-da-proposta`, params)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Proposal Validation
	 * @return {Promise<any[]>}
	 */
	static validateAdmission() {
		return AxiosService.get(`${baseURL}/validar-admissao`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Generate Card
	 * @return {Promise<any[]>}
	 */
	static CardRegister(params) {
		return AxiosService.post(`${baseURL}/gerar-cartao`, params)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Get info card
	 * @return {Promise<any[]>}
	 */
	static GetCardInfo() {
		return AxiosService.get(`${baseURL}/buscar-cartao`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	// Meu cartao endpoints
	/**
	 * Get info card
	 * @return {Promise<any[]>}
	 */
	static GetInvoiceInfo(cardPersonId, competence) {
		return AxiosService.post(`${baseURL}/fatura`, {
			CardPersonId: cardPersonId,
			competence,
		})
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Get first invoice info to show
	 * @return {Promise<any[]>}
	 */
	static GetFirstInvoiceInfoToShow(cardPersonId) {
		return AxiosService.get(`${baseURL}/fatura/${cardPersonId}`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Get info about invoices
	 * @return {Promise<any[]>}
	 */
	static GetInvoices(cardPersonId) {
		return AxiosService.post(`${baseURL}/buscar-faturas`, {
			cardPersonId,
		})
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Get info card
	 * @return {Promise<any[]>}
	 */
	static GetInstallmentsOptions(totalValue) {
		return AxiosService.getKeepLatest(
			'muvicard-installments',
			`${baseURL}/buscar-opcoes-parcelamento?totalValue=${totalValue}`
		)
			.then(({ data }) => data)
			// getMuvicardInstallmentOptions le response.data - precisa manter o
			// mesmo formato do sucesso, senao response.data.length estoura.
			// Exceto o cancelamento (keep latest): a chamada superada nao e "sem parcelas",
			// e quem a chamou descarta o resultado.
			.catch((error) => (isRequestCanceled(error) ? Promise.reject(error) : { data: [] }))
	}

	/**
	 * Request new password
	 * @return {Promise<any[]>}
	 */
	static RedefinePasswordRequest(cardPersonId) {
		var params = {
			cardPersonId,
		}
		return AxiosService.post(
			`${baseURL}/solicitar-alteracao-de-senha`,
			params
		)
	}

	/**
	 * Generate new password
	 * @return {Promise<any[]>}
	 */
	static RedefinePassword(token, password) {
		return AxiosService.post(`${baseURL}/redefinir-senha`, {
			token: token,
			password: password,
		})
	}

	/**
	 * Validate token to generate new password
	 * @return {Promise<any[]>}
	 */
	static ValidateTokenForPasswordReset(token) {
		return AxiosService.post(`${baseURL}/validar-token-redefinicao-senha`, {
			token: token,
		})
	}

	/**
	 * Cancellation card
	 * @return {Promise<any[]>}
	 */
	static CardCancellation(reason) {
		return AxiosService.post(`${baseURL}/cancelar-cartao`, {
			reason: reason,
		})
	}

	/**
	 * Block card
	 * @return {Promise<any[]>}
	 */
	static CardBlock() {
		return AxiosService.post(`${baseURL}/bloquear-cartao`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * UnBlock card
	 * @return {Promise<any[]>}
	 */
	static CardUnblock() {
		return AxiosService.post(`${baseURL}/desbloquear-cartao`)
			.then(({ data }) => data)
			.catch(() => [])
	}

	/**
	 * Download Muvicard Contract
	 * @return {Promise<any[]>}
	 */
	static async DownloadMuvicardContract() {
		AxiosService.get(`${baseURL}/baixar-contrato-de-servicos-muvicard`, {
			responseType: 'blob',
		})
			.then((response) => {
				const { data } = response
				if (data) {
					fileSaver(data, 'Contrato-de-Serviços-Muvicard.pdf')
				}
			})
			.catch(() => [])
	}

	/**
	 * Download Invoice Bankslip
	 * @return {Promise<any[]>}
	 */
	static async DownloadInvoiceBankslip(key, month) {
		AxiosService.get(`${baseURL}/boleto/${key}`, {
			responseType: 'blob',
		})
			.then((response) => {
				const { data } = response
				if (data) {
					fileSaver(data, `Fatura ${month}.pdf`)
				}
			})
			.catch(() => [])
	}

	/**
	 * Download of partial invoice
	 * @return {Promise<any[]>}
	 */
	static async GenerateParcialInvoice(value) {
		return AxiosService.get(
			`${baseURL}/gerar-fatura-parcial?value=${value}`,
			{ responseType: 'blob' }
		)
	}
}
